import { useMemo } from "react";

import { controlActivitiesListColumnFiltersCodecMap } from "@impero-com/ui/domain";
import * as Sentry from "@sentry/react";

import {
    ALL_ACTIVITIES_SCOPE,
    buildControlActivitiesListDefaultState,
} from "org/controlActivities/list/consts";
import { getActiveCategoryNames } from "org/controlActivities/list/utils/category";
import { useTagsSuspenseQuery } from "org/tags/queries/useTagsQuery";

import { ActivitiesUrlDependencies } from "../utils/activitiesUrl";

export function useActivitiesUrlDependencies(): ActivitiesUrlDependencies {
    const { data: tags } = useTagsSuspenseQuery();

    return useMemo(() => {
        const categoryNames = getActiveCategoryNames(tags.tagCategories);
        return {
            defaultValues: buildControlActivitiesListDefaultState(
                categoryNames,
                ALL_ACTIVITIES_SCOPE
            ),
            columnFiltersCodecMap: controlActivitiesListColumnFiltersCodecMap,
            onError: Sentry.captureException,
        };
    }, [tags]);
}
